import { useContext } from 'react';
import { AppContext } from '../components/AppContext';

export const useWidgetProperties = function <T>(widgetInstanceId?: string): T {
    const { document } = useContext(AppContext);

    const widgetInstances = document?.widgetInstances;
    const widgetInstance = (widgetInstances || {})[widgetInstanceId || ''];
    const refId = widgetInstance?.refId;

    if (refId && widgetInstanceId) {
        const refComponentInstance = widgetInstances?.[refId];
        return {
            ...widgetInstance?.properties,
            ...refComponentInstance?.customizations?.[widgetInstanceId]?.properties,
        } as any;
    }

    return widgetInstance?.properties as T;
};
